module.exports = __webpack_public_path__ + "static/img/banner2.b05b374.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/publicClass/banner2.png
// module id = vsNi
// module chunks = 23